<template>
  <Teleport to="body">
    <div class="modal-overlay" @mousedown.self="$emit('close')">
      <dialog class="card modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Создание интеграции ГЛОНАССсофт</h3>
          <button
            class="close-btn"
            type="button"
            @click="$emit('close')"
          >
            ✕
          </button>
        </div>

        <form
          @submit.prevent="createIntegration"
          class="integration-form"
        >
          <div class="form-body custom-scroll" ref="formBodyRef">
            <div class="form-group">
              <base-label for="login" :required="true">
                Логин
              </base-label>
              <base-input
                type="text"
                id="login"
                v-model="formData.login"
                :invalid="errors.login"
                @update:modelValue="
                  formData.login = $event || '';
                  errors.login = false;
                "
              />
              <span class="error-message" v-if="errors.login">
                Поле обязательно для заполнения
              </span>
            </div>

            <div class="form-group">
              <base-label for="password" :required="true">
                Пароль
              </base-label>
              <base-input
                id="password"
                v-model="formData.password"
                :is-password="true"
                :invalid="errors.password"
                @update:modelValue="
                  formData.password = $event || '';
                  errors.password = false;
                "
              />
              <span class="error-message" v-if="errors.password">
                Поле обязательно для заполнения
              </span>
            </div>
          </div>

          <div class="form-actions sticky-footer">
            <base-primary-button
              icon="addSquare"
              class="form-btn"
              type="submit"
              :disabled="isSubmitting"
            >
              <span v-if="isSubmitting">Создание...</span>
              <span v-else>Создать интеграцию</span>
            </base-primary-button>
            <base-button
              class="form-btn"
              type="button"
              @click="$emit('close')"
              :disabled="isSubmitting"
            >
              Отмена
            </base-button>
          </div>
        </form>
      </dialog>
    </div>
  </Teleport>
</template>

<script>
import { useIntegrationStore } from "@/stores/integrationStore";

export default {
  name: "AddGlonasssoftIntegrationModal",
  emits: ["close", "action-created"],
  data() {
    return {
      isSubmitting: false,

      formData: {
        login: "",
        password: "",
        provider_type: "Integration::Glonasssoft",
      },

      errors: {
        login: false,
        password: false,
      },
    };
  },
  computed: {
    integrationStore() {
      return useIntegrationStore();
    },
  },
  methods: {
    validateForm() {
      let isValid = true;
      this.errors = { login: false, password: false };

      if (!String(this.formData.login || "").trim()) {
        this.errors.login = true;
        isValid = false;
      }
      if (!String(this.formData.password || "").trim()) {
        this.errors.password = true;
        isValid = false;
      }

      return isValid;
    },

    async createIntegration() {
      if (!this.validateForm()) return;

      try {
        this.isSubmitting = true;

        await this.integrationStore.createIntegration(this.formData);

        this.$emit("action-created");
        this.$emit("close");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid var(--color-grey);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  flex-shrink: 0;
}

.modal-title {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.close-btn:hover {
  color: var(--color-dark);
  background: #f5f5f5;
}

.integration-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.form-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}

.error-message {
  display: block;
  margin-top: 5px;
  color: var(--color-danger);
  font-size: 14px;
}

.sticky-footer {
  padding: 20px;
  border-top: 1px solid var(--color-grey);
  background: #fff;
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  flex-shrink: 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 767px) {
  .sticky-footer {
    gap: 10px;
  }

  .sticky-footer button {
    flex: 1;
  }
}
</style>
